import React from 'react';
import { Box, Typography } from '@mui/material';
import { IMG_SRC } from '../../constants';

export const UNMAPPED_PRODUCT_TOOLTIP_MESSAGE = [
  { type: 'unmatchedSKU', msg: 'Inventory SKU and Catalogue SKU have different value' },
  {
    type: 'notFulfillable',
    msg: 'No Inventory linked to the Catalogue Product. Item will not be fulfillable by Warehouse.',
  },
];

export const COLUMNS_WITH_HELPING_ICONS = ['Sellable Stock:', 'Marketplace Locked Stock:', 'Marketplace Stock:'];

export const STORAGE_TYPE_OPTIONS = [
  { label: 'Ambient', value: 'ambient' },
  { label: 'Temp Controlled', value: 'tempcontrolled' },
  { label: 'Cold Storage', value: 'coldstorage' },
  { label: 'High Value', value: 'highvalue' },
];

export const packLevelsImg = [
  IMG_SRC.PACK_HEIRARCHY_UNIT,
  IMG_SRC.PACK_HEIRARCHY_PRIMARY,
  IMG_SRC.PACK_HEIRARCHY_SECONDARY,
  IMG_SRC.PACK_HEIRARCHY_TERTIARY,
];

export const INVENTORY_DETAIL_TOOLTIP_MESSAGES = {
  WAREHOUSE_STOCK:
    'The total stock of the SKU in the Locad warehouse Warehouse Stock = Available Stock + Reserved Stock + Buffer Stock + Locked Stock',
  RESERVED_STOCK:
    ' The stock that is reserved for orders in an ONHOLD, PREORDER, NEW, PARTIAL and UNPAID status on the Locad dashboard.',
  BUFFER_STOCK:
    'The physical stock at the warehouse that is not part of the Sellable or Reserved stock. It is kept aside as a buffer in case of exchanges, promotions, or any other purpose you would require.',
  TOTAL_LOCKED_STOCK: 'The sum of locked stock from all catalogue SKUs mapped to the inventory product. ',
  AVAILABLE_STOCK:
    'The stock that is available to sell in your online stores. Available Stock = Warehouse Stock - Reserved Stock - Buffer Stock - Locked Stock',
  WAREHOUSE_STOCK_SELLABLE: 'Total usable inventory that is synced and available for sale on the marketplace.',
  WAREHOUSE_STOCK_USABLE: (
    <Box>
      <Box>
        Total undamaged inventory for an SKU stored in the warehouse, including both available (free) and allocated
        stock.
      </Box>
      <Box>
        Note: Usable stocks don’t always equal sellable stocks. There may be packed or already allocated quantities that
        are usable but can’t be assigned to new orders.
      </Box>
    </Box>
  ),
  WAREHOUSE_STOCK_UNUSABLE: 'Total damaged or missing inventory for an SKU that cannot be sold or used.',
};

export const PACK_HIERARCHY_DOC_LINK =
  'https://help.golocad.com/en/support/solutions/articles/70000675143-inventory-product-pack-hierarchy';

export const PACK_HIERARCHY_ENABLED_TEXT =
  'Pack Hierarchy enables stock handling at higher pack levels (e.g., cartons), improving throughput and driving significant cost savings.';

export const PACK_HIERARCHY_DISABLED_TEXT = (
  <Typography variant="body1" color="text.secondary">
    Pack Hierarchy enables stock handling at higher pack levels (e.g., cartons), improving throughput and driving
    significant cost savings. <br /> This feature is currently not enabled for your account. Please reach out to your
    account manager to request activation.
  </Typography>
);

export const PRODUCT_INVENTORY_SYNC_TOOLTIP =
  'Turning off Inventory Sync means Locad will no longer update stock levels on the connected marketplace for the catalogue SKU.';

// Color constants
export const DETAIL_INPUT_COLORS = {
  BLACK: '#000000',
  DISABLED_BACKGROUND: 'rgba(0, 0, 0, 0.04)',
  DISABLED_BORDER: 'rgba(0, 0, 0, 0.23)',
};

export const ADDITIONAL_BARCODES_NOT_SUPPORTED_TEXT =
  'Additional barcodes are only supported in Logiwa and Wareo 2 WMS';
